import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export function Nav() {
  const { artist, loading } = useAuth()

  return (
    <nav className="nav">
      <div className="nav-inner container">
        <Link to="/" className="nav-brand">ORIGINALENE</Link>
        <div className="nav-links">
          {!loading && (
            artist ? (
              <Link to="/dashboard">{artist.name}</Link>
            ) : (
              <Link to="/login">Artist login</Link>
            )
          )}
        </div>
      </div>
    </nav>
  )
}
